<template>
  <div class="home">
    <ProgressStep step=4 />
    <p class="stepReminder">Étape 4/4</p>
    <h1>Parcours</h1>
    <div class="inputFrame">
      <p :class="{ 'unselectedError' : noSelected }">Sélectionne un parcours dans la liste</p>
      <div v-if="noSelected" class="radioFrameWarning">
        <p>Sélectionne une proposition</p>
      </div>
      <RadioDiploma
        v-for="(item, i) in radioData"
        :key="i" :diploma="item"
        :itemKey="i"
        :selected="$store.state.diploma"
        @click="noSelected = false; disabled = ''"
      />
    </div>
    <button @click="goToNext()" class="submit-button" :style="disabled">Calculer</button>
    <button @click="$router.push({ name: 'Etape-3' })" class="submit-button-back">
      <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
      <span>Étape précédente</span>
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressStep from '@/components/ProgressStep.vue'
import RadioDiploma from '@/components/RadioDiploma.vue'

export default {
  name: 'Etape4',
  components: {
    ProgressStep,
    RadioDiploma
  },
  data () {
    return {
      location: null,
      radioData: [
        'Programme Grande École',
        'Global Bachelor in Management',
        'Bachelor Tourism Management',
        'Designer Concepteur de projets',
        'Bachelor',
        'BPJEPS',
        'Autre'
      ],
      targetDiploma: null,
      noSelected: false,
      disabled: 'background-color: #C3C4CA'
    }
  },
  mounted () {
    this.$store.state.diploma = null
  },
  methods: {
    goToNext () {
      if (this.$store.state.diploma !== null) {
        this.$router.push({ name: 'Resultat' })
      } else {
        // error
        this.noSelected = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .submit-button {
      margin-top: 48px;
      padding: 20px 40px;
      display: block;
      justify-content: unset;
      align-items: unset;
    }
    .unselectedError {
      color: var(--color-danger);
    }
    .inputFrame {
      margin-top: 30px;
      p {
        margin: 0;
        margin-bottom: 10px;
      }
      input {
        border: solid 1px #9FA7A7;
        border-radius: 3px;
        padding: 11px 13px;
        width: calc(100% - 28px);
        font-weight: 400;
        font-size: 17px;
        color: #000000;
        text-align: left;
        margin-top: 10px;
      }
    }
    .radioFrameWarning {
      accent-color: var(--color-danger);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 20px;
      border: solid 1px var(--color-danger);
      border-radius: 12px;
      width: calc(100% - 22px + 20px - 31px - 11px);
      margin-bottom: 12px;
      background-color: #f4e8e8;
      p {
          text-align: left;
          font-weight: 700;
          font-size: 16px;
          letter-spacing: 0.38px;
          color: var(--color-danger);
          width: 100%;
          margin-bottom: unset;
      }
    }
  @media screen and (min-width: 585px) {
    
  }
</style>
